import React, { useCallback, useMemo } from "react";
import { ProductCardMemo } from "@muchbetteradventures/styleguide";

var Hit = function Hit(_ref) {
  var hit = _ref.hit,
      imageSizes = _ref.imageSizes,
      index = _ref.index,
      onClick = _ref.onClick,
      renderPrice = _ref.renderPrice;
  var productId = hit.productID;
  var imageUrls = useMemo(function () {
    return hit.images.map(function (image) {
      if (image && image.url) return image.url;
      if (typeof image === "string") return image;
      return "";
    }).slice(0, 1);
  }, [hit.images]);
  var reviewScore = hit.reviewScore ? hit.reviewScore.toFixed(1) : "NEW";
  var reviewCount = hit.reviewScore ? hit.reviewCount : undefined;
  var priceString = renderPrice(parseInt(hit.price, 10), hit.currency, true);
  var handleClick = useCallback(function (e) {
    if (onClick) onClick(e, hit, index);
  }, [hit, index]);
  return /*#__PURE__*/React.createElement(ProductCardMemo, {
    backgroundColor: "lightGrey",
    productId: productId,
    name: hit.name,
    images: imageUrls,
    imageSizes: imageSizes,
    price: priceString,
    locations: hit.country,
    currencySymbol: "",
    duration: hit.duration,
    reviewCount: reviewCount,
    reviewScore: reviewScore,
    onClick: handleClick,
    season: hit.season,
    url: hit.url,
    shortlistComponent: null
  });
};

export default Hit;